import * as Yup from "yup";

export function getValidatorPostalCode(country: string) {
  switch (country) {
    case "US":
      return validatorUSZipCode.required("Required");
    case "CA":
      return validatorCAPostalCode.required("Required");
    default:
      return validatorInternationalPostalCode.required("Required");
  }
}

const validatorUSZipCode = Yup.string().matches(/^[0-9]{5}$/, "Not valid");

const validatorCAPostalCode = Yup.string().matches(
  /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z][ ]?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/,
  "Not valid"
);

const validatorInternationalPostalCode = Yup.string().matches(
  /^[a-zA-Z0-9 -]+$/,
  "Not valid"
);
